













import { ValidationError } from '@/models';
import { isMaxLengthRuleBroken } from '@/shared';
import { camelToKebabCase } from '@/utils';
import Vue from 'vue';

export default Vue.extend({
  name: 'InputValidationInfo',
  props: {
    inputRef: {} as () => any,
  },
  computed: {
    inputName(): string {
      if (this.inputRef?.$vnode ) {
        return camelToKebabCase(this.inputRef.$vnode.data.ref);
      } else {
        return this.inputRef.name;
      }
    },
    firstByInputName(): string {
      const items = ((this as any).errors as any).items.filter((e: any) => e.field === this.inputName);
      return items.length ? items[0].msg : '';
    },
  },
  methods: {
    // Check if 'max' type error for a specified ref name exists in error bag
    isMaxLengthErrorMessageDisplayed(): boolean {
      return isMaxLengthRuleBroken(this, this.inputName);
    },
  },
});
